export const Services = ({ data=[] }) => (
<section id="services" className="section section--services-v7" aria-labelledby="services-title">
  <div className="services-orbit-v71" aria-hidden="true"><i/><i/><i/></div>
  <div className="site-container services-shell-v71">
    <header className="services-head-v71" data-motion>
      <div className="services-head-copy-v71">
        <p className="eyebrow">CAPABILITIES</p>
        <h2 id="services-title">필요한 기술을<br/><span>하나의 흐름으로 연결합니다.</span></h2>
      </div>
      <div className="services-intro-v71">
        <span>FROM IDEA TO OPERATION</span>
        <p>기획과 화면, 업무 로직과 백엔드를 따로 보지 않습니다. 실제 서비스가 운영되는 순간까지 필요한 기술을 하나의 흐름으로 연결합니다.</p>
      </div>
    </header>

    <div className="service-flow-v71" aria-hidden="true">
      <span>IDEA</span><i/><b>BUILD</b><i/><span>RUN</span>
    </div>

    <div className="service-panels-v71">
      {data.map((s,i)=><article className="service-panel-v71" key={s.name} data-motion>
        <div className="service-panel-bg-v71" aria-hidden="true"/>
        <div className="service-panel-top-v71"><span>0{i+1}</span><i>↗</i></div>
        <div className="service-panel-copy-v71">
          <p>{s.subtitle}</p>
          <h3>{s.name}</h3>
          <strong>{s.text}</strong>
        </div>
        <div className="service-panel-tags-v71">{s.tags?.map(t=><b key={t}>{t}</b>)}</div>
      </article>)}
    </div>
  </div>
</section>
);
